import { ActionTypes } from '../constants/index';

export const ecommerceInfo = (payload: any) => ({
  type: ActionTypes.ECOMMERCE_INFO_LIST_REQUEST,
  payload,
});
